import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import theme from './theme';
import Routes from './Components/Routes/Routes';
import GlobalStyle from './GlobalStyle';
import FlashNotificationProvider from './Pages/Notification/FlashNotificationProvider';
import FlashNotificationContainer from './Pages/Notification/FlashNotificationContainer';

export const history = createBrowserHistory();

function App() {
  return (
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <FlashNotificationProvider>
          <CssBaseline />
          <GlobalStyle />
          <Routes />
          <FlashNotificationContainer />
        </FlashNotificationProvider>
      </ThemeProvider>
    </Router>
  );
}
export default App;
